import React, { useEffect, useRef } from 'react';
var SnippylyCommentTool = function (props) {
    var targetCommentElementId = props.targetCommentElementId, targetElementId = props.targetElementId, onCommentModeChange = props.onCommentModeChange, sourceId = props.sourceId, children = props.children, darkMode = props.darkMode, variant = props.variant, shadowDom = props.shadowDom;
    var ref = useRef();
    var onCommentModeChangeRef = useRef(onCommentModeChange);
    // Update the ref to always point to the latest callback function
    useEffect(function () {
        onCommentModeChangeRef.current = onCommentModeChange;
    }, [onCommentModeChange]);
    useEffect(function () {
        var element;
        var handleCommentModeChange = function (event) {
            if (onCommentModeChangeRef.current) {
                onCommentModeChangeRef.current(event === null || event === void 0 ? void 0 : event.detail);
            }
        };
        if (ref.current) {
            element = ref.current;
            if (element) {
                element.addEventListener('onCommentModeChange', handleCommentModeChange);
            }
        }
        return function () {
            if (element) {
                element.removeEventListener('onCommentModeChange', handleCommentModeChange);
            }
        };
    }, []);
    return (React.createElement("velt-comment-tool", { ref: ref, "target-comment-element-id": targetCommentElementId, "target-element-id": targetElementId, "source-id": sourceId, variant: variant, "shadow-dom": [true, false].includes(shadowDom) ? (shadowDom ? 'true' : 'false') : undefined, "dark-mode": [true, false].includes(darkMode) ? (darkMode ? 'true' : 'false') : undefined }, children));
};
export default SnippylyCommentTool;
